module.exports = __webpack_public_path__ + "img/august_900.f7db55c9.png";